import $ from 'jquery';

$(function() {
  function killEvent(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    return false;
  }
  $('.application_form').on('submit', function(evt) {
    var form = evt.currentTarget;
    var data = new FormData(form);

    $(form).find('.form-error').text('').hide();
    $(form).find('.is-invalid, .is-valid').removeClass('is-invalid is-valid');
    $(form).removeClass('was-validated');
    $(form).addClass('needs-validation');

    if (form.checkValidity() === false) {
      return killEvent(evt);
    }
    $(form).addClass('was-validated');


    // passes browser validation
    $.ajax({
      url: '/api/careers',
      method: 'POST',
      enctype: 'multipart/form-data',
      processData: false,
      contentType: false,
      data: data,
      success: function(data) {
        console.log(data);
        // receives server side validation errors as well as success message
        if (data.status == 'error') {
          var guid = $(form).attr('id');
          if (data.message) {
            // generic error
            $(form).find('.form-error').text(data.message).removeClass('d-none');
          } else if (data.validation) {
            for (var key in data.validation.Errors) {
              var field = $('#' + guid + '_' + key);
              field.siblings('.invalid-feedback').text(data.validation.Errors[key].join('<br/>'));
              field.addClass('is-invalid');
            }
          }
        } else {
          //success! replace the from with the confirmation message
          $(form).text(data.message);
        }
      }
    });
    
    return killEvent(evt);
  })
})